<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import {computed, onMounted} from '@vue/composition-api';
    import {DateTime} from "luxon";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config.js";

    export default {
        name: 'EventReportBusinessMatching',
        setup(props, {root}) {
            const {Event, EventMatching} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const dbColMapping = eConfig.reportBusinessMatching.dbColMapping;
            
            const exportReport = async () => {
                const event = await Event.get(eventId.value);
                const {data: matchingArr} = await EventMatching.find({
                    query: {
                        eventId: eventId.value,
                    },
                });
                
                let colWidth = {};
                for (const [key, value] of Object.entries(dbColMapping)) {
                    colWidth[value] = key.length;
                }
                
                let excelData = [];
                for (const matching of matchingArr) {
                    const row = [];
                    for (const value of Object.values(dbColMapping)) {
                        if (value === 'eg_1' || value === 'eg_2') {
                            row.push(matching[value]['ev_email']);
                        } else if (value === 'start_time' || value === 'end_time') {
                            row.push(DateTime.fromISO(matching[value]).setZone('Asia/Hong_Kong').toFormat('dd/LL/yyyy HH:mm:ss'));
                        } else {
                            row.push(matching[value]);
                        }

                        if (row[row.length - 1] && (!colWidth[value] || colWidth[value] < row[row.length - 1].length)) {
                            colWidth[value] = row[row.length - 1].length;
                        }
                    }
                    excelData.push(row);
                }
                
                excelData.unshift([...Object.keys(dbColMapping)]);
                const ws = XLSX.utils.aoa_to_sheet(excelData);
                if(!ws["!cols"]) ws["!cols"] = [];
                let colIndex = 0;
                for (const value of Object.values(dbColMapping)) {
                    if (!ws["!cols"][colIndex]) {
                        ws["!cols"][colIndex] = {wch: colWidth[value]};
                    }
                    colIndex++;
                }

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, event.name);
                XLSX.writeFile(wb, 'business_matching_report_'+eventId.value+'_'+DateTime.local().toFormat('yyyyMMdd_HHmmss')+'.xlsx');
                
                root.$router.go(-1);
            }
            
            onMounted(() => {
                exportReport();
            });

            return {
            }
        },
    }
</script>
